import React from 'react';

const ALLE = [
  { wert: 'werkstudent',        label: 'Werkstudentenstelle' },
  { wert: 'minijob',            label: 'Minijob' },
  { wert: 'midijob',            label: 'Midijob' },
  { wert: 'schnellverdienst',   label: 'Schnell Geld verdienen' },
  { wert: 'praktikum',          label: 'Praktikum' },
  { wert: 'lehrstelle',         label: 'Berufsausbildung / Lehrstelle' },
  { wert: 'quereinstieg',       label: 'Quereinstieg' },
  { wert: 'junior',             label: 'Einstiegsjob / Junior' },
  { wert: 'karriere',           label: 'Nächster Karriereschritt' },
  { wert: 'neuer_job',          label: 'Neuer Job' },
  { wert: 'fuehrung',           label: 'Führungsposition' },
  { wert: 'freiberuflich',      label: 'Freiberuflich' },
  { wert: 'selbststaendig_machen', label: 'Selbstständig machen' },
];

const ARBEITSZEIT_OPTIONEN = [
  { wert: 'vollzeit',  label: 'Vollzeit' },
  { wert: 'teilzeit',  label: 'Teilzeit' },
  { wert: 'minijob',   label: 'Minijob' },
  { wert: 'midijob',   label: 'Midijob' },
  { wert: 'egal',      label: 'Flexibel' },
];

const LABEL_MAP = Object.fromEntries(ALLE.map(o => [o.wert, o.label]));

const GRUPPEN = {
  student: [
    { label: 'WÄHREND DES STUDIUMS', werte: ['werkstudent', 'praktikum', 'minijob'] },
    { label: 'NACH DER AUSBILDUNG / ABSCHLUSS', werte: ['junior', 'karriere', 'lehrstelle'] },
    { label: 'SELBSTBESTIMMT',       werte: ['freiberuflich', 'selbststaendig_machen', 'quereinstieg'] },
    { label: 'SONSTIGES',            werte: ['fuehrung', 'schnellverdienst'] },
  ],
  ausbildung: [
    { label: 'EINSTIEG & KARRIERE', werte: ['junior', 'lehrstelle', 'karriere', 'neuer_job'] },
    { label: 'SOFORT & NEBENBEI',   werte: ['schnellverdienst', 'minijob', 'midijob', 'werkstudent'] },
    { label: 'EIGENER WEG',         werte: ['selbststaendig_machen', 'freiberuflich', 'quereinstieg'] },
    { label: 'WEITERES',            werte: ['fuehrung', 'praktikum'] },
  ],
  angestellt: [
    { label: 'AUFSTEIGEN',     werte: ['fuehrung', 'karriere', 'quereinstieg'] },
    { label: 'NEU ANFANGEN',   werte: ['junior', 'lehrstelle', 'praktikum'] },
    { label: 'SELBSTSTÄNDIG',  werte: ['freiberuflich', 'selbststaendig_machen'] },
    { label: 'NEBENBEI',       werte: ['minijob', 'schnellverdienst', 'werkstudent'] },
  ],
  selbststaendig: [
    { label: 'ZURÜCK IN ANSTELLUNG', werte: ['karriere', 'fuehrung', 'junior'] },
    { label: 'STANDBEIN AUSBAUEN',   werte: ['freiberuflich', 'quereinstieg', 'lehrstelle'] },
    { label: 'EXTRA EINNAHMEN',      werte: ['minijob', 'schnellverdienst', 'werkstudent'] },
    { label: 'WEITERENTWICKELN',     werte: ['selbststaendig_machen', 'praktikum'] },
  ],
  freelancer: [
    { label: 'FESTANSTELLUNG',       werte: ['fuehrung', 'karriere'] },
    { label: 'MEHR STABILITÄT',      werte: ['junior', 'quereinstieg', 'lehrstelle'] },
    { label: 'SELBST AUFBAUEN',      werte: ['selbststaendig_machen', 'schnellverdienst', 'praktikum'] },
    { label: 'FLEXIBEL BLEIBEN',     werte: ['minijob', 'werkstudent', 'freiberuflich'] },
  ],
  arbeitslos: [
    { label: 'SOFORT GELD',    werte: ['schnellverdienst', 'minijob', 'werkstudent'] },
    { label: 'NEUSTART',       werte: ['junior', 'praktikum', 'lehrstelle'] },
    { label: 'KARRIEREZIEL',   werte: ['karriere', 'fuehrung', 'quereinstieg'] },
    { label: 'SELBSTSTÄNDIG',  werte: ['selbststaendig_machen', 'freiberuflich'] },
  ],
  jobsuchend: [
    { label: 'ZIEL DEFINIEREN',  werte: ['karriere', 'fuehrung'] },
    { label: 'FLEXIBEL',         werte: ['quereinstieg', 'junior', 'lehrstelle'] },
    { label: 'SELBST AUFBAUEN',  werte: ['freiberuflich', 'selbststaendig_machen'] },
    { label: 'ÜBERBRÜCKEN',      werte: ['minijob', 'schnellverdienst', 'werkstudent', 'praktikum'] },
  ],
  pause: [
    { label: 'WIEDEREINSTIEG',   werte: ['karriere', 'junior', 'quereinstieg'] },
    { label: 'SCHRITTWEISE',     werte: ['minijob', 'werkstudent', 'praktikum'] },
    { label: 'SELBST WAGEN',     werte: ['freiberuflich', 'selbststaendig_machen', 'schnellverdienst'] },
    { label: 'ZIEL SETZEN',      werte: ['fuehrung', 'lehrstelle'] },
  ],
};

export default function StepBeschaeftigung({ wert, onChange, antworten }) {
  const status    = antworten?.status?.status ?? null;
  const gruppen   = GRUPPEN[status];
  const ziel      = wert?.ziel      ?? null;
  const arbeitszeit = wert?.arbeitszeit ?? null;

  function setzeZiel(w) {
    onChange({ ziel: w, arbeitszeit });
  }

  function setzeArbeitszeit(w) {
    onChange({ ziel, arbeitszeit: w });
  }

  let chipIdx = 0;
  const zielChips = gruppen
    ? gruppen.map((gruppe, gi) => (
        <div key={gi}>
          <div className="ob-group-label">{gruppe.label}</div>
          <div className="ob-chips">
            {gruppe.werte.map(w => {
              const delay = `${0.05 + chipIdx++ * 0.05}s`;
              return (
                <button
                  key={w}
                  type="button"
                  className={`ob-chip ob-chip--animate${ziel === w ? ' ob-chip--aktiv' : ''}`}
                  style={{ animationDelay: delay }}
                  onClick={() => setzeZiel(w)}
                >
                  {LABEL_MAP[w]}
                </button>
              );
            })}
          </div>
        </div>
      ))
    : (
      <div className="ob-chips">
        {ALLE.map((o, i) => (
          <button
            key={o.wert}
            type="button"
            className={`ob-chip ob-chip--animate${ziel === o.wert ? ' ob-chip--aktiv' : ''}`}
            style={{ animationDelay: `${0.05 + i * 0.05}s` }}
            onClick={() => setzeZiel(o.wert)}
          >
            {o.label}
          </button>
        ))}
      </div>
    );

  return (
    <div className="ob-step-enter">
      {zielChips}
      <div className="ob-arbeitszeit-section">
        <div className="ob-group-label">ARBEITSZEIT</div>
        <div className="ob-chips">
          {ARBEITSZEIT_OPTIONEN.map((o, i) => (
            <button
              key={o.wert}
              type="button"
              className={`ob-chip ob-chip--animate${arbeitszeit === o.wert ? ' ob-chip--aktiv' : ''}`}
              style={{ animationDelay: `${0.05 + (chipIdx + i) * 0.05}s` }}
              onClick={() => setzeArbeitszeit(o.wert)}
            >
              {o.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
